import React, { useState, useEffect } from "react";
import { Button, Grid, Stack } from "@mui/material";
import { IDiagnosticLink } from "../../../model/DiagnosticLink";
import PropTypes from "prop-types";
import { useCustDiagStore } from "../../../contexts/RootStoreProvider";
import { observer } from "mobx-react-lite";

const WizardCardAnswers = (props: any) => {
  const [optionsList, setOptionsList] = useState([] as IDiagnosticLink[]);

  const custDiagStore = useCustDiagStore();

  const handleAnswerOnClick = (stepId: number, label: string) => {
    if (stepId !== undefined) {
      custDiagStore.getNextDiagnosticStep(stepId, label);
    }
  };

  const options = optionsList.map((opt: IDiagnosticLink) => (
    <Button
      key={opt.destId}
      onClick={() => {
        handleAnswerOnClick(opt.destId, opt.label);
      }}
      variant="contained"
    >
      {opt.label}
    </Button>
  ));

  useEffect(() => {
    if (props.options !== undefined) {
      setOptionsList(props.options);
    }
  }, [props]);

  return (
    <Grid container alignContent={"center"}  spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <Stack alignContent={"center"} justifyContent="center" spacing={2} direction="row">
          {options}
        </Stack>
      </Grid>
    </Grid>
  );
};

WizardCardAnswers.propTypes = {
  options: PropTypes.any,
};

export default observer(WizardCardAnswers);
